// File Metadata:
// Filename: dateUtils.js
// Version: 1.00
// Created: 2025-07-14
// Last Modified: 2025-07-14
// Authors: Dieuwer Descheemaecker, GitHub Copilot
// Description: Shared date utility functions used across the application

import { startOfWeek } from 'date-fns';

/**
 * Get the Monday of the current week at 00:00:00.000.
 * Uses date-fns startOfWeek with weekStartsOn: 1 (Monday).
 * @returns {Date} Monday of the current week
 */
export const getCurrentWeekStart = () => {
  return startOfWeek(new Date(), { weekStartsOn: 1 });
};

/**
 * Get the Monday of the week that contains the given date.
 * @param {Date|string} date - The date to get the week start for
 * @returns {Date} Monday of the week containing the given date
 */
export const getWeekStartForDate = (date) => {
  return startOfWeek(new Date(date), { weekStartsOn: 1 });
};
